<template>
  <footer
    class="app-footer"
    :class="[`app-footer--theme-${theme}, app-footer--variant-${variant}`]">
    <div :class="[insert ? 'app-footer__container' : 'container']">
      <div class="app-footer__inner">
        <div class="app-footer__info">
          <div class="app-footer__social social">
            <h5>Мы в соцсетях</h5>
            <div class="social__list">
              <a
                href="https://vk.com/nticontest"
                class="social__item"
                target="_blank"
                title="Мы в Vk"
                rel="noopener noreferrer">
                <BaseIcon
                  glyph="vk"
                  width="18px" />
              </a>
              <a
                href="https://max.ru/nticontest"
                class="social__item"
                target="_blank"
                title="Мы в Max"
                rel="noopener noreferrer">
                <BaseIcon
                  glyph="max"
                  width="18px" />
              </a>
              <a
                href="https://t.me/nto_olympiada"
                class="social__item"
                target="_blank"
                title="Мы в Telegram"
                rel="noopener noreferrer">
                <BaseIcon
                  glyph="telegram"
                  width="18px" />
              </a>
              <!-- <a
                href="https://www.facebook.com/nticontest/"
                class="social__item"
                target="_blank"
                rel="noopener noreferrer"
              >
                <BaseIcon glyph="fb" width="18px" />
              </a>
              <a
                href="https://www.instagram.com/nti_contest/"
                class="social__item"
                target="_blank"
                rel="noopener noreferrer"
              >
                <BaseIcon glyph="instagram" width="18px" />
              </a> -->
            </div>
          </div>
          <div class="app-footer__support">
            <h5>Служба поддержки</h5>
            <a
              class="app-footer__support-mail"
              :class="{ landing: variant === 'landing' }"
              :href="`mailto:${$store.state.supportEmail}`"
              >{{ $store.state.supportEmail }}</a
            >
          </div>
          <div
            class="sb-box"
            :class="{ landing: variant === 'landing' }">
            <h5 v-if="variant === 'landing'">Специальная версия сайта</h5>
            <BviButton
              theme="blue"
              variant="landing"
              :button-text="variant === 'landing' ? 'Включить' : undefined"
              class="sb-box__button" />
          </div>

          <div class="app-footer__links">
            <slot name="links"></slot>
          </div>
        </div>
        <div class="app-footer__box">
          <template v-if="variant === 'landing'">
            <div
              class="app-footer__top"
              @click="scrollToTop">
              Наверх
            </div>
          </template>

          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            class="app-footer__logo"
            :class="{ horizontal: variant === 'landing' }">
            <img
              v-if="variant === 'landing'"
              src="@/assets/images/logo-horizontal_white.png"
              alt="Национальная технологическая олимпиада"
              class="app-footer__logo-horizontal" />

            <img
              v-else
              src="@/assets/images/nto_logo_white.png"
              alt="Национальная технологическая олимпиада" />
          </a>
        </div>
      </div>

      <div class="app-footer__bottom">
        <div class="rsv-copy">
          НКО &laquo;Ассоциация участников технологических кружков&raquo;
          115054, г. Москва, ул. Дубининская, д.&nbsp;11&nbsp;стр.&nbsp;2, а/я
          97&nbsp;ОГРН 1177700010718&nbsp;ИНН 7714997200
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import BviButton from "@/components/BviButton.vue";

export default {
  name: "AppFooter",
  components: { BviButton },
  props: {
    theme: {
      type: String,
      default: "dark", // light, transparent
    },
    insert: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: "default", // landing
    },
  },
  methods: {
    scrollToTop() {
      if (
        typeof window === "undefined" ||
        typeof window.scrollTo !== "function"
      ) {
        return;
      }
      try {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } catch (e) {
        window.scrollTo(0, 0);
      }
    },
  },
};
</script>

<style lang="less">
.app-footer {
  padding-top: 30px;
  padding-bottom: 30px;
  margin-top: 40px;
  border-top: 1px solid @lp-outline-color;
  background-color: lighten(@bg-dark, 2%);
  color: @lp-base-color;
  position: relative;

  &__container {
    max-width: 86%;
    padding: 0 20px;
    margin: 0 auto;
  }

  &__box {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-self: stretch;

    @media (max-width: @screen-sm) {
      align-self: flex-end;
    }
  }

  &__top {
    transition: color 0.3s;
    cursor: pointer;
    margin-left: auto;

    &:hover {
      color: @link-blue;
    }

    @media (max-width: @screen-sm) {
      position: absolute;
      top: 0;
      right: 0;
    }
  }

  &__logo {
    width: 120px;
    max-width: 120px;
    aspect-ratio: ~"592 / 555";

    & img {
      width: 120px;
      max-width: 120px;
      aspect-ratio: ~"592 / 555";
    }

    &.horizontal {
      width: 182px;
      max-width: 182px;
      aspect-ratio: ~"182 / 48";
    }

    &.horizontal &-horizontal {
      width: 182px;
      max-width: 182px;
      aspect-ratio: ~"182 / 48";

      & img {
        width: 182px;
        max-width: 182px;
        aspect-ratio: ~"182 / 48";
        min-width: 150px;
      }
    }
  }

  &__inner {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  a {
    text-decoration: none;
    color: @lp-base-color;
  }

  &__info {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    max-width: 700px;
    margin-right: 30px;
  }

  &__social {
    margin-right: 50px;
  }

  &__support {
    display: flex;
    flex-direction: column;

    &-mail {
      font-size: 22px;
      font-weight: 600;
      line-height: 1;
      text-transform: uppercase;
      padding: 15px 0px;
      color: @lp-base-color;
      border-radius: 50px;
      transition: color 0.3s;

      &:hover {
        color: @link-blue;
      }
    }
  }

  &__links {
    display: flex;
    justify-content: space-between;
    flex-grow: 1;
    margin-top: 24px;
    margin-left: -10px;
    margin-right: -10px;

    a {
      margin: 0 10px;
    }

    a:hover {
      text-decoration: underline;
    }
  }

  &--theme-light {
    background-color: lighten(@bg-color, 2%);
    border-top: none;
    color: @grey-blue;

    a {
      color: @grey-blue;
    }
  }

  &--theme-light &__support-mail {
    color: @grey-blue;

    &:hover {
      color: @link-blue;
    }
  }

  &--theme-transparent {
    background-color: transparent;
    border-top: none;
    color: @grey-blue;

    a {
      color: @grey-blue;
    }
  }

  &--variant-landing {
    background-color: transparent;
    border-top: none;
    color: @white-blue;

    a {
      color: @white-blue;
    }
  }

  &--variant-landing &__support {
    margin-right: 50px;
  }

  &--variant-landing &__support-mail {
    padding: 15px 24px;
    background-color: #03103c;
    border-radius: 4px;
    margin-top: 17px;
    width: fit-content;
  }

  &--variant-landing .social__item {
    background-color: #03103c;
    border-radius: 50%;
    width: 52px;
    height: 52px;
  }

  &--variant-landing &__info {
    max-width: 830px;
    gap: 30px 0;
  }

  &--variant-landing &__links {
    margin-top: 0;

    @media (max-width: @screen-sm) {
      margin-top: 30px;
      width: 100%;
      padding-right: 0;
      & a {
        width: 100%;
      }
    }
  }

  &--variant-landing &__box {
    align-items: flex-end;
  }

  &__bottom {
    width: 100%;
  }

  @media (max-width: @screen-lg) {
    &__container {
      max-width: 100%;
    }
  }

  @media (max-width: @screen-sm) {
    &__info {
      display: block;

      flex: 0 1 auto;
    }
    &__inner {
      position: relative;
      flex-wrap: wrap;
    }
    &__support {
      margin-top: 30px;
    }

    &__links {
      display: block;
      a {
        display: block;
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    &__logo {
      margin-top: 20px;
    }
  }

  @media (max-width: @screen-xs) {
    &__social {
      margin-right: 0;
    }

    &__support {
      &-mail {
        padding: 10px 0;
        font-size: 20px;
      }
    }

    &__links {
      font-size: 14px;
      padding-right: 110px;
    }

    &__inner {
      position: relative;
      flex-wrap: wrap;
    }

    &__info {
      margin-right: 0;
      width: 100%;
      flex-shrink: 0;
    }

    &__logo {
      margin-top: 20px;
      max-width: 250px;
    }
  }
  @media (max-width: @screen-xs) {
    &__logo {
      width: 100px;

      &.horizontal {
        width: 182px;
      }
    }
  }
}
.social {
  &__list {
    display: flex;
    margin-top: 17px;
  }

  &__item {
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    width: 18px;
    transition: color 0.3s;
    margin-right: 26px;

    &:last-child {
      margin-right: 0;
    }

    &:hover {
      color: @link-blue;
    }

    &::before {
      content: "";
      width: 32px;
      height: 32px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
.sb-box {
  margin-left: auto;
  display: flex;
  align-items: flex-start;
  align-self: flex-start;
  margin-top: -4px;

  & button {
    align-self: flex-start;
  }

  @media screen and (max-width: @screen-lg) {
    & .bvi-text {
      display: none;
    }
  }

  @media screen and (max-width: @screen-sm) {
    & .bvi-text {
      display: block;
    }
  }

  &.landing {
    display: block;
    margin-top: 0;
    margin-left: 0;

    & button {
      margin-top: 17px;
      padding: 15px 24px;
      height: 52px;
      background-color: #03103c;
    }

    @media screen and (max-width: @screen-lg) {
      & .bvi-text {
        display: block;
      }
    }

    @media screen and (max-width: @screen-sm) {
      margin-top: 30px;
    }
  }
}

.rsv-copy {
  // font-size: 15px;
  // text-align: right;
  // padding: 25px 0;
  // opacity: 0.75;
  margin-top: 40px;
  background-color: rgba(0, 0, 0, 0.2);
  padding: 12px;
  font-size: 14px;
  background-color: #03103c;
  // text-align: center;
}
</style>
